<template>
  <div class="popup wide">
    <Loader v-if="loading" />
    <h4 class="popup__title middle">Сообщение</h4>

    <div class="form">
      <div class="form__item">
        <div class="input">
          <input type="text" placeholder="Тема" v-model="subject">
        </div>
      </div>
      <div class="form__item">
        <div class="textarea">
          <textarea placeholder="Текст" v-model="content" rows="9"/>
        </div>
      </div>
    </div>

    <div class="actions">
      <button class="button btn-primary" @click="closeAll()">Отмена</button>
      <button class="button btn-primary"
              @click="sendEmailsFunc()"
              :disabled="subject === '' || content === ''"
              :style="{ opacity: subject === '' || content === '' ? '.6' : '' }"
      >
        Отправить
      </button>
    </div>
  </div>
</template>

<script>
import {popups} from '@/mixins/popups'
import {mapActions, mapState} from "vuex";
import Loader from '@/components/common/Loader.vue'

export default {
  name: "removeClientPopup",
  mixins: [popups],
  components: {
    Loader
  },
  data: () => ({
    loading: false,
    subject: '',
    content: '',
  }),
  computed: {
    ...mapState({
      client: state => state.popups.client,
    })
  },
  methods: {
    ...mapActions({
      sendEmails: 'sendEmails',
    }),
    async sendEmailsFunc() {
      this.loading = true
      await this.sendEmails({subject: this.subject, content: this.content})

      this.loading = false
    },
  },
  mounted() {}
}
</script>

<style scoped lang="scss">
@import "../../styles/variables";

.popup {
  :deep(.loader) {
    height: 200%;
    width: 200%;
    left: -50%;
    top: -50%;
    border-radius: 25px;
    transform: scale(0.5);
    svg {
      position: unset;
    }
  }
}

.wide {
  max-width: unset;
  width: 560px;
  max-height: 80%;

  .form {
    //flex-direction: row;
    //justify-content: space-between;
    width: 100%;
    //overflow-y: auto;
    //overflow-x: hidden;
    //gap: 6px;

    .form__item {
      margin-bottom: 10px;
      .label {
        width: 83px;
      }
      input {
        width: calc(100% - 20px) !important;
      }
    }
  }
}
</style>